import React from "react";
import style from "../../styles/footer.module.scss";
import logo from "../../assets/images/logoWhite.svg";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { CiFacebook } from "react-icons/ci";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineEmail } from "react-icons/md";

const Footer = () => {
  return (
    <footer className={style.container}>
      <div className={style.innerContainer}>
        <div className={style.col}>
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        <div className={style.col}>
          <Link to="/">Home</Link>
          <Link to="/about-us">About Us</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>
        <div className={style.col}>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>

          <Link to="/" className={style.hidden}>
            Transporti
          </Link>
        </div>
        <div className={style.col}>
          <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
            <FaInstagram size={20} /> Instagram
          </a>
          <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
            <CiFacebook size={25} /> Facebook
          </a>

          <a href="tel:+44123123" target="_blank" rel="noreferrer">
            <BiPhoneCall size={25} /> +44 20 3002 3808
          </a>
          <a href="mailto:contact@hopa.com" target="_blank" rel="noreferrer">
            <MdOutlineEmail size={25} /> contact@hopa-uk.com
          </a>
        </div>
      </div>
      <div className={style.copyright}>
        <p>&copy; {new Date().getFullYear()} Hopa L.L.C</p>
      </div>
    </footer>
  );
};

export default Footer;
